/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @fullcalendar components
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

// Custom styles for Calendar
import CalendarRoot from "./CalendarRoot";

import moment from "moment";
import { Link } from "react-router-dom";


function Calendar({ header = { title: "", date: "" }, ...rest }) {
  // console.log(rest)
  const validClassNames = [
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ];

  var events = [];
  var now = moment().unix();

  if (rest.events) {
    for (var event of rest.events) {
      // create two event markers from one event
      // console.log(event)
      var ret = {};
      ret.title = event.name + ": Warning Period " + moment(event.display_time).format("h:mm A");
      ret.start = moment(event.display_time).format("YYYY-MM-DD");
      ret.end = moment(event.start_time).format("YYYY-MM-DD");
      if (now > moment(event.end_time).unix()) {
        ret.className = 'event-preactive-old sibling-left fc-daygrid-past-event';
      }
      else {
        ret.className = 'event-preactive sibling-left fc-daygrid-past-event';
      }
      ret.event_id = event._id;
      events.push(ret);

      var ret = {};
      ret.title = event.name + ": ACTIVE " + moment(event.start_time).format("h:mm A") + " - " + moment(event.end_time).format("h:mm A");
      ret.start = moment(event.start_time).format("YYYY-MM-DD");
      ret.end = moment(event.end_time).format("YYYY-MM-DD");
      if (now > moment(event.end_time).unix()) {
        ret.className = 'event-active-old sibling-right fc-daygrid-past-event';
      }
      else {
        ret.className = 'event-active sibling-right fc-daygrid-upcoming-event';
      }
      ret.event_id = event._id;
      events.push(ret);
    }
  }

  function eventsContent(eventInfo) {
    return (
      <Link to={eventInfo.event.extendedProps.event_id} style={{textDecoration: 'none'}}>
        <SoftBox className="fc-event-title">{eventInfo.event.title}</SoftBox>
      </Link>
    );
  }

  return (
    <SoftBox sx={{ height: "100%" }}>
      <CalendarRoot pt={1} pb={2} px={2}>
        <FullCalendar
          {...rest}
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          events={events}
          eventContent={eventsContent}
          height="100%"
        />
      </CalendarRoot>
    </SoftBox>
  );
}

// Typechecking props for the Calendar
Calendar.propTypes = {
  header: PropTypes.shape({
    title: PropTypes.string,
    date: PropTypes.string,
  }),
};

export default Calendar;
